import type { SearchPreferences } from './searchPreferences';

export type SearchPreferenceDefaults = {
  excludeNudity?: boolean;
};

const withNudityDefault = <T extends { excludeNudity?: boolean }>(
  scope: T,
  defaults: SearchPreferenceDefaults
): T => ({
  ...scope,
  excludeNudity: scope.excludeNudity ?? defaults.excludeNudity,
});

/**
 * Fills preference fields from profile defaults wherever the visitor has stated
 * nothing.
 *
 * `stored ?? default` — a stored `false` is a choice that survives. Only
 * "never stated" (undefined) falls through to the default.
 *
 * `excludeNudity` is the only such default today, applied only to the two
 * scopes that store a nudity choice (`isNudityFilterScope`). The filter is
 * also offered on searches that store nothing about it, and filling a default
 * there would write a choice the stored form has no field for.
 *
 * The caller extracts the relevant fields from whatever profile object it
 * holds, so this function does not need to know what a SearchProfile is.
 */
export const applyDefaults = (
  preferences: SearchPreferences,
  defaults: SearchPreferenceDefaults
): SearchPreferences => ({
  ...preferences,
  creativeImage: withNudityDefault(preferences.creativeImage, defaults),
  creativeImageFilm: withNudityDefault(preferences.creativeImageFilm, defaults),
});
